import { Link } from "@tanstack/react-router"
import {
  CalendarDays,
  LogIn,
  LogOut,
  RefreshCw,
  ShieldCheck,
} from "lucide-react"
import { useState } from "react"

import { signOutDemoFn } from "@/server/functions"

import { Brand } from "./brand"
import { Button } from "./ui/button"

type HeaderViewer = {
  name: string
  role: "golfer" | "staff" | "manager"
  avatarInitials: string
}

export function PublicHeader({ viewer }: { viewer: HeaderViewer | null }) {
  const [signingOut, setSigningOut] = useState(false)

  async function signOut() {
    setSigningOut(true)
    await signOutDemoFn()
    window.location.assign("/")
  }

  return (
    <header className="public-header">
      <div className="site-frame flex h-full items-center justify-between gap-4">
        <Link
          to="/"
          className="inline-flex min-h-11 items-center"
          aria-label="Groundline booking home"
        >
          <Brand compact />
        </Link>
        <nav className="flex items-center gap-1 sm:gap-2" aria-label="Main">
          {viewer?.role === "golfer" ? (
            <>
              <Button
                render={<Link to="/my-bookings" />}
                variant="ghost"
                size="sm"
                aria-label="My bookings"
              >
                <CalendarDays data-icon="inline-start" />
                <span className="hidden sm:inline">My bookings</span>
              </Button>
              <Button
                render={<Link to="/membership" />}
                variant="ghost"
                size="sm"
                aria-label="Player Pass"
              >
                <RefreshCw data-icon="inline-start" />
                <span className="hidden md:inline">Player Pass</span>
              </Button>
            </>
          ) : null}
          {viewer?.role === "staff" || viewer?.role === "manager" ? (
            <Button
              render={<Link to="/staff" />}
              variant="outline"
              size="sm"
              aria-label="Staff desk"
            >
              <ShieldCheck data-icon="inline-start" />
              <span className="hidden sm:inline">Staff desk</span>
            </Button>
          ) : null}
          {viewer ? (
            <>
              <span
                className="avatar-token ml-1"
                title={`Signed in as ${viewer.name}`}
                aria-label={`Signed in as ${viewer.name}`}
              >
                {viewer.avatarInitials}
              </span>
              <Button
                variant="ghost"
                size="icon-sm"
                aria-label="Sign out"
                title="Sign out"
                disabled={signingOut}
                onClick={signOut}
              >
                <LogOut />
              </Button>
            </>
          ) : (
            <Button
              render={<Link to="/login" />}
              variant="outline"
              size="sm"
              className="login-entry-button"
            >
              <LogIn data-icon="inline-start" />
              Log in
            </Button>
          )}
        </nav>
      </div>
    </header>
  )
}
